import React from "react";
import { Preloader } from "../../Preloader/preloader";
import "../Popup.css";

interface IConfirmPopup {
  openDeletePopup: boolean;
  setOpenDeletePopup: React.Dispatch<React.SetStateAction<boolean>>;
  deleteAccount: () => void;
  errorMessage: { status: boolean; message: string };
  setErrorMessage: React.Dispatch<
    React.SetStateAction<{ status: boolean; message: string }>
  >;
  deleteLoader: boolean;
}

export const ConfirmPopup: React.FC<IConfirmPopup> = ({
  openDeletePopup,
  setOpenDeletePopup,
  deleteAccount,
  errorMessage,
  setErrorMessage,
  deleteLoader,
}) => {
  React.useEffect(() => {
    window.addEventListener("keyup", handleEscClose, false);
    document.addEventListener("click", overlayClickClose, false);
    return () => {
      window.removeEventListener("keyup", handleEscClose);
      document.removeEventListener("click", overlayClickClose);
    };
  }, [openDeletePopup]);

  function handleCloseDeletePopup() {
    setOpenDeletePopup(false);
    setErrorMessage({...errorMessage, status: false, message: ""});
  }

  function deleteChosenAcc() {
    deleteAccount();
  }

  const overlay = React.useRef<HTMLDivElement>(null);

  function handleEscClose(event: KeyboardEvent) {
    if (event.key === "Escape") {
      handleCloseDeletePopup();
    }
  }

  function overlayClickClose(event: Event) {
    if (overlay.current && overlay.current === event.target) {
      handleCloseDeletePopup();
    }
  }

  return (
    <div
      className={openDeletePopup ? "popup popup_opened" : "popup"}
      ref={overlay}
    >
      <div className="popup-confirm__container">
        <p className="popup-confirm__title">
          Вы уверены, что хотите удалить выбранный лицевой счет?
        </p>
        {errorMessage.message && (
          <span className="popup-confirm__error">
            {errorMessage.message}
          </span>
        )}
        {deleteLoader && <Preloader small={true} />}
        <div className="popup-confirm__button-block">
          <button
            type="button"
            className="popup-confirm__button"
            onClick={handleCloseDeletePopup}
            disabled={deleteLoader}
          >
            Отмена
          </button>
          <button
            type="button"
            className="popup-confirm__button popup-confirm__button_delete"
            onClick={deleteChosenAcc}
            disabled={deleteLoader}
          >
            Удалить
          </button>
        </div>
      </div>
    </div>
  );
};
